import styled from 'styled-components';
import { Container } from 'styles';

export const StyledContainer = styled(Container).attrs({
  flex: true,
  margin: { right: '32px', top: '24px' },
  padding: '16px',
  small: { margin: { right: '0' } },
})`
  background: ${props =>
    props.color && props.theme.colors.background[props.color]};
  border-radius: ${props => props.theme.borderRadii.large};
`;
